/**
 * Splits a filename into the file name and file extension
 * @param filename
 * @returns [file name, file extension]
 */
export function splitFileName(filename: string): [string, string] {
	const index = filename.lastIndexOf(".")
	if (index == -1) return [filename, ""]
	return [filename.substring(0, index), filename.substring(index + 1).toLowerCase()]
}
